/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";

import { ReactComponent as PersonList } from "../Assets/svg/PersonList.svg";
import { ReactComponent as DownloadIcon } from "../Assets/svg/DownloadIcon.svg";


import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";


import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";

import moment from "moment-jalaali"

import { ReactComponent as SreachIcon } from "../Assets/svg/SreachIcon.svg";

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';


import http from '../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';

import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../Components/persian-mobile-datepicker-config'
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import ModalComponent from './ModalComponent';
import { SearchCities } from './PublicFunctions';
import Cookies from 'js-cookie'
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function MyInfoModal(props) {

    const { enqueueSnackbar } = useSnackbar();


    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    const [myInfoModal, setMyInfoModal] = useState(false);

    const [openProvinceModal, setOpenProvinceModal] = React.useState(false);
    const [provinceSelected, setProvinceSelected] = React.useState(false);
    const [province, setProvince] = React.useState(null);
    const [provinceTitle, setProvinceTitle] = React.useState(null);
    const [city, setCity] = React.useState(null);
    const [cityTitle, setCityTitle] = React.useState(Cookies.get('locationName'));
    const [cityProvince, setCityProvince] = React.useState([]);

    const [myInfoList, setMyInfoList] = React.useState({});
    const [showSubmitDatePicker, setShowSubmitDatePicker] = React.useState(false);
    const [openZoneModal, setOpenZoneModal] = React.useState(false);
    const [openTypeZone, setOpenTypeZone] = React.useState(false);


    const navigate = useNavigate();

    const userInfo = JSON.parse(localStorage.getItem("agency"))

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };



    const handleClickOpenProvinceModal = () => {
        setOpenProvinceModal(true);
    };

    const handleProvinceClose = () => {
        setOpenProvinceModal(false);
    };

    const dataFetchedRef = useRef(false);


    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // getUsers()
        getProvinces()
        getAreas()

        // console.log("date",  moment())
        console.log("myInfoUse",props.myInfoList)
         

    }, [])



    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }





    const handleProvinceSelected = async (e) => {
        setProvince(e.target.value)
        setProvinceTitle(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/locations/province/cities/list",
                method: "POST",
                data: {
                    "ProvinceId": e.target.value,
                }
            }).then((res) => {

                setCityProvince(res.data.result.Cities)
                setProvinceSelected(true)
                handleCloseBackdrop()

            });
        } catch (e) {
            console.error(e);

            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            handleCloseBackdrop()
        }
    };

    const handleSetCity = (e) => {
        console.log("city")
        setCity(e.target.value)
        setCityTitle(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        console.log("cityTitle", cityTitle)
        props.handleSeMyInfoList("LocationId", e.target.value)
    }


    const handleBackToProvince = (e) => {
        console.log("back")
        setCity(null)
        props.handleSeMyInfoList("LocationId", "")
        setProvince(null)
        setCityTitle(null)
        setProvinceSelected(false)
        getProvinces()
    }

    const getProvinces = () => {
        if (!localStorage.getItem('provinces')) {
            http.post('/locations/provinces/list')
                .then(response => {
                    setCityProvince(response.data.result.Provinces)
                    localStorage.setItem('provinces', JSON.stringify(response.data.result.Provinces))
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        } else {
            console.log(JSON.parse(localStorage.getItem('provinces')))
            setCityProvince(JSON.parse(localStorage.getItem('provinces')))
        }
    }

    const handleSearch = async (e) => {
        if (provinceSelected) {

            handleToggleBackdrop()
            try {
                await http({

                    url: "/locations/province/cities/list",
                    method: "POST",
                    data: {
                        "ProvinceId": province ? province : '',
                        "Name": e.target.value
                    }
                }).then((res) => {
                    setCityProvince(res.data.result.Cities)
                    setProvinceSelected(true)
                    handleCloseBackdrop()
                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }



        } else {
            if (e.target.value != "") {
                console.log("SearchCities", SearchCities(e.target.value, cityProvince))
                setCityProvince(SearchCities(e.target.value, cityProvince))
            } else {
                getProvinces()
            }
        }

    }



    useEffect(() => {
        setCityTitle(cityTitle)
    }, [cityTitle])

     

    //Areas Pagination
    const [areasItems, setAreasItems] = React.useState([]);

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);
    const [typeZone, setTypeZone] = React.useState(1);

    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClose = () => {
        setOpenZoneModal(false);
    };

    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {

            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 40);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    useEffect(() => {
        console.log("offset use")

        if (hasMoreOffset && areasItems.length) {
            if (typeZone == "1")
                getAreas(false, "", "/areas/list")
            if (typeZone == "2")
                getAreas(false, "", "/webapp/divar_areas/list")
        }
    }, [areaOfsset])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
        }

        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 40
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 1000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }

    const areasSearchHandle = async (e) => {

        handleToggleBackdrop()
        if (e.target.value != "") {
            if (typeZone == "1")
                getAreas(true, e.target.value, "/areas/list")
            if (typeZone == "2")
                getAreas(true, e.target.value, "/webapp/divar_areas/list")
        } else {
            if (typeZone == "1")
                getAreas(true, "", "/areas/list")
            if (typeZone == "2")
                getAreas(true, "", "/webapp/divar_areas/list")
        }
    }

    useEffect(() => {
        console.log("typeZone", typeZone)
        if (typeZone == "1")
            getAreas(true, "", "/areas/list")
        if (typeZone == "2")
            getAreas(true, "", "/webapp/divar_areas/list")


    }, [typeZone])


    ///////////////////////
    const handleOpenTypeZoneClose = () => {
        setOpenTypeZone(false);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClickTypeZone = () => {
        setOpenTypeZone(true);
    };

    return (
        <>
            <ModalComponent showModalState={props.myInfoModal} handleModalClose={props.handleMyInfoModalClose} modalTitle="" modalSubmitBtn={props.saveMyInfo} modalTitleSubmitBtn="ذخیره">
                <Box sx={{ width: '100%' }} >
                    <label htmlFor='meter' className='f-16 text-label'>تاریخ ثبت</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        <div className='flex-1 w-chile-100'>

                            <InputBase value={formatJalali(props.myInfoList["RegisterDate"] && props.myInfoList["RegisterDate"])} className='flex-1' onClick={() => setShowSubmitDatePicker(true)} />
                            <Picker
                                isOpen={showSubmitDatePicker}
                                config={config}
                                value={props.myInfoList["RegisterDate"] && props.myInfoList["RegisterDate"]}
                                initialValue={new Date(props.myInfoList["RegisterDate"] ? new Date(props.myInfoList["RegisterDate"]) : new Date())}
                                minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                onSubmit={selectedDate => props.handleSeMyInfoList("RegisterDate", +selectedDate.date)}
                                onClose={() => setShowSubmitDatePicker(false)}
                                highlightWeekends
                            />
                        </div>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='meter' className='f-16 text-label'>نام واحد اقتصادی</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='meter' placeholder='' value={props.myInfoList?.AgencyName} onChange={e => props.handleSeMyInfoList("AgencyName", e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='meter' className='f-16 text-label'>همراه</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='meter' inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' placeholder='' value={props.myInfoList?.AgencyMobile} onChange={e => props.handleSeMyInfoList("AgencyMobile", e.target.value)} />
                    </Box>
                    <Typography variant='p' sx={{ color: '#29A19C', fontSize: '12px', marginTop: '-10px' }}>با این شماره همراه وارد پایش شدید</Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='meter' className='f-16 text-label'>نام مدیر</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='meter' placeholder='' value={props.myInfoList?.Username} onChange={e => props.handleSeMyInfoList("Username", e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='meter' className='f-16 text-label'>تلفن ثابت</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='meter' placeholder='' value={props.myInfoList?.AgencyTel} onChange={e => props.handleSeMyInfoList("AgencyTel", e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='email' className='f-16 text-label'>ایمیل</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='email' placeholder='' value={props.myInfoList?.AtomEmail} onChange={e => props.handleSeMyInfoList("AtomEmail", e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='website' className='f-16 text-label'>وب سایت</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='website' placeholder='' value={props.myInfoList?.Website} onChange={e => props.handleSeMyInfoList("Website", e.target.value)} />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label'>شهر</label>
                    <Box className="inputs-container" onClick={handleClickOpenProvinceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        <span>
                            {/* {provinceTitle && provinceTitle} */}
                            {cityTitle && cityTitle}
                        </span>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label className='f-16 text-label'>محدوده</label>
                    <Box className="inputs-container" onClick={handleClickOpenZoneModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                        <span>
                            {props.myInfoList?.Area}
                        </span>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Box>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <label htmlFor='address' className='f-16 text-label'>آدرس</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                        <InputBase id='address' placeholder='' value={props.myInfoList?.PhysicalAddress} onChange={e => props.handleSeMyInfoList("PhysicalAddress", e.target.value)} />
                    </Box>
                </Box>
            </ModalComponent>


            {openProvinceModal && <ModalComponent showModalState={openProvinceModal}
                handleModalClose={handleProvinceClose}
                modalTitle="انتخاب شهر"
                modalSubmitBtn={handleProvinceClose}
                modalTitleSubmitBtn="انتخاب"
                modalHeaderRightBtn={provinceSelected ? true : false} headerRightBtnClass="green-btn" headerRightBtnFunction={handleBackToProvince} headerRightBtnTitle="استان ها">
                <Box sx={{ color: '#8F8F8F' }}>
                    <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                        <InputBase placeholder='جستجو کنید...' className='flex-1' onChange={handleSearch} />
                        <IconButton>
                            <SreachIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Grid container spacing={3}>
                            {cityProvince && cityProvince.length ? cityProvince.map((item, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="radio" name='cityProvince' value={item.Id} id={`cityProvince${index}`} className="d-none floorCheck" onChange={!provinceSelected ? handleProvinceSelected : handleSetCity} checked={!provinceSelected ? province == item.Id : city == item.Id} />
                                    <label htmlFor={`cityProvince${index}`} className='inputs-container floorLabel w-100'>
                                        <span className="flex-1">{item.FarsiName}</span>
                                    </label>
                                </Grid>
                            )) : <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box>}
                        </Grid>
                    </Box>
                </Box>
            </ModalComponent>}

            {openZoneModal && <ModalComponent showModalState={openZoneModal}
                handleModalClose={handleClose}
                modalTitle="انتخاب محدوده"
                modalSubmitBtn={handleClose}
                modalTitleSubmitBtn="انتخاب"
                modalHeaderRightBtn={true}
                headerRightBtnFunction={handleClickTypeZone}
                headerRightBtnTitle={<SettingIcon />}
                hasSpecificParent={true}>

                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important", overflow: 'auto' }} id="areas-container">
                    <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                        <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                        <IconButton>
                            <SreachIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px', height: "100%" }}>
                        <Grid container spacing={3}>

                            {
                                areasItems && areasItems.length > 0 ?
                                    areasItems.map((item, index) => (

                                        <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                            <input type="checkbox" id={`areas${index}`} value={item.Name} onChange={(e) => {
                                                props.handleSeMyInfoList("Area", e.target.value)
                                                handleClose()
                                            }} checked={props.myInfoList?.Area == item.Name} className="d-none typeCheck" />
                                            <label htmlFor={`areas${index}`} className='typeLabel'>
                                                {item.Name}
                                            </label>
                                        </Grid>
                                    ))
                                    : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                areasLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                            }
                        </Grid>
                    </Box>
                </Box>
            </ModalComponent >}

            {openTypeZone && <ModalComponent showModalState={openTypeZone}
                handleModalClose={handleOpenTypeZoneClose}
                modalTitle=""
                modalSubmitBtn={handleOpenTypeZoneClose}
                modalTitleSubmitBtn="جستجو"
            // modalHeaderRightBtn={true}
            // headerRightBtnFunction={handleClickTypeZone}
            // headerRightBtnTitle={<SettingIcon />}
            // hasSpecificParent={true}
            >
                <Box>
                    <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={typeZone == "1"} value="موارد خودم" onChange={() => setTypeZone("1")} />
                    <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                        <PersonList />
                        موارد خودم
                    </label>
                </Box>
                <Box>
                    <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={typeZone == "2"} value="موارد دریافتی از پایش" onChange={() => setTypeZone("2")} />
                    <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                        <DownloadIcon />
                        موارد دریافتی از پایش
                    </label>
                </Box>
            </ModalComponent>}


        </>
    );
}

export default MyInfoModal;